import { 
  LOADING_NOTIFICACIONES, 
  FETCH_TOTAL_NOTIFICACIONES,
  FETCH_DETALLE_NOTIFICACIONES, 
  CHANGE_TAB_ACTIVA_NOTIFICACIONES,
  FETCH_LEIDAS_NOTIFICACIONES,
  FETCH_AJUSTES_NOTIFICACIONES
} from '../actions/types';

import { 
  fetchTotalNotificacionesApi, 
  fetchDetalleNotificacionesApi,
  fetchMarcarLeidasNotificacionesApi,
  fetchAjusteNotificacionesApi
} from "../api/axios";

export const fetchTotalNotificaciones = (params) => async dispatch => {

  const req = fetchTotalNotificacionesApi(params);

  req.then((response) => {

    dispatch({
      type: FETCH_TOTAL_NOTIFICACIONES,
      payload: response.total
    });
  })
}

export const fetchDetalleNotificaciones = (params) => async dispatch => {

  dispatch({
    type: LOADING_NOTIFICACIONES,
    payload: true
  });

  const req = fetchDetalleNotificacionesApi(params);

  req.then((response) => {

    dispatch({
      type: FETCH_DETALLE_NOTIFICACIONES,
      payload: response.elementos
    });

    dispatch({
      type: LOADING_NOTIFICACIONES,
      payload: false
    });
  })
}

export const fetchMarcarLeidasNotificaciones = (params) => async dispatch => {

  const req = fetchMarcarLeidasNotificacionesApi(params);

  req.then((response) => {

    dispatch({
      type: FETCH_LEIDAS_NOTIFICACIONES,
      payload: response.elementos
    });
  })
}


export const changeTabActiva = (params) => async dispatch => {
  dispatch({
    type: CHANGE_TAB_ACTIVA_NOTIFICACIONES,
    payload: params.idTabActiva
  });
}

export const fetchAjusteNotificaciones = (params) => async dispatch => {

  dispatch({
    type: LOADING_NOTIFICACIONES,
    payload: true
  });

  const req = fetchAjusteNotificacionesApi(params);

  req.then((response) => {

    dispatch({
      type: FETCH_AJUSTES_NOTIFICACIONES,
      payload: response.opcionesNotificacion
    });

    dispatch({
      type: LOADING_NOTIFICACIONES,
      payload: false
    });
  })
}